import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";
import apiRequestType from "../../apiRequestType";

let cancelToken;
const getUserShotClassReport = (
  fromDate,
  pageNumber,
  pageSize,
  reportMode,
  toDate,
  trainingType,
  userId
) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  if (reportMode === "View") {
    return apiRequestType(
      apiTypes.GET,
      apiConstants.REPORT.TABULAR_REPORT.USER_SHOTCLASS_REPORT(
        fromDate,
        pageNumber,
        pageSize,
        reportMode,
        toDate,
        trainingType,
        userId
      ),
      "",
      cancelToken
    );
  } else {
    let url =
      encodeURIComponent(apiConstants.BASE_URL_1) +
      encodeURIComponent(
        apiConstants.REPORT.TABULAR_REPORT.USER_SHOTCLASS_REPORT(
          fromDate,
          pageNumber,
          pageSize,
          reportMode,
          toDate,
          trainingType,
          userId
        )
      );
    let template = "UserShotClassReport";
    return apiRequestType(
      apiTypes.GET,
      apiConstants.REPORT.CSV_REPORT(url, template),
      "",
      cancelToken
    );
  }
};

export default getUserShotClassReport;
